/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AccreditationApi } from '../api/accreditation.api';
import { switchMap, map } from 'rxjs/operators';
import { AccreditationData, Accreditation } from '../../../interfaces/masters/accreditation';

@Injectable()
export class AccreditationService extends AccreditationData {

  constructor(private api: AccreditationApi) {
    super();
  }


  list(): Observable<Accreditation[]> {
    return this.api.list();
  }

  getById(url:string): Observable<Accreditation>{
      return this.api.getById(url);
  }

  create(url: string, data:Accreditation): Observable<Accreditation> {
    return this.api.add(url,data);
  }

  update(url: string, data:Accreditation): Observable<Accreditation> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
